import { render, staticRenderFns } from "./RestaurantTable.vue?vue&type=template&id=15a33ca6&scoped=true"
import script from "./RestaurantTable.vue?vue&type=script&lang=js"
export * from "./RestaurantTable.vue?vue&type=script&lang=js"
import style0 from "./RestaurantTable.vue?vue&type=style&index=0&id=15a33ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a33ca6",
  null
  
)

export default component.exports